import Close from "src/components/Close/styles";
import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";
import {
  BlockFormGroup,
  Form as StyledForm,
  Label as StyledLabel,
} from "src/styles/form";
import Modal from "src/styles/modal";
import styled from "styled-components";

export const GroupsTableContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 400px;
  height: calc(100vh - 300px);
  overflow: hidden;
`;

export const GridWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const New = styled(Modal)`
  > div > div > .ReactModal__Content {
    left: 16% !important;
    right: 22% !important;
    width: 70%;
    top: 4% !important;
    min-height: auto;
    max-height: 92%;
    bottom: auto !important;
    height: auto;
    overflow-y: auto !important;
    &.ReactModal__Content--after-open {
      overflow-y: auto !important;
    }
  }
`;

export const FormGroup = styled(BlockFormGroup)`
  padding-left: 0px;
`;

export const Label = styled(StyledLabel)`
  padding-left: 0px;
  font-size: 12.5px;
`;

export const Form = styled(StyledForm)`
  padding: 0 2em;
  min-height: 100%;
  h3 {
    margin: 0 -1.5em;
    margin-bottom: 1em;
    position: relative;
    text-transform: capitalize;
    background: ${colors.grey0};
    padding: ${spacing.space_inset_l};
    padding-left: 1.7em;
    font-weight: bold;
  }

  ${Close} {
    top: 1em;
    right: 1em;
  }
`;

export const Picture = styled.div`
  border: 1px dashed ${colors.grey6};
  background: transparent;
  width: 8em;
  height: 8em;
  line-height: 1.67;
  color: ${colors.secondary};
  border-radius: 12px;
  display: inline-grid;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 1em;
  margin-bottom: 0;
  > input {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  > span {
    font-weight: bold;
  }
  :hover {
    > span {
      transition: 0.25s;
      color: ${colors.primary};
    }
  }
  img {
    width: 8em;
    height: 8em;
    border-radius: 12px;
  }
`;

export const PictureBox = styled.div`
  display: flex;
  align-items: flex-end;

  > span {
    color: ${colors.active};
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.8em;
  padding-bottom: 0.5em;
`;

export const Lock = styled.div<{ locked?: boolean; secondary?: string }>`
  padding: 1em 0.8em;
  cursor: pointer;
  border: 1px solid
    ${(props) =>
      props.locked ? props.secondary || colors.secondary : colors.grey4};
  > h5 {
    margin: 0px;
  }
`;
